module.exports = __webpack_public_path__ + "img/dsc_giris_logo.b275c841.png";